import { expiration } from 'creditcards';

export default (year) => {
  return expiration.year.isValid(
    expiration.year.parse(year)
  );
}
